import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ApplicationUsersState } from '../../_reducers/settings/application-users.reducers';
const getApplicationUsers = createFeatureSelector<any>('application-users');


export const getProductsLoading = createSelector(
  getApplicationUsers,
  (state: any) => state.productsLoading
);
/**
 * Select All All Application Users
 */

export const getAllUsers = createSelector(
  getApplicationUsers,
  (state: any) => state.users
);

/**
 * Select Products
 */
export const getProducts = createSelector(
  getApplicationUsers,
  (state: any) => state.products
);

/**
 * Select Company Users
 */
export const getCompanyUsers = createSelector(
  getApplicationUsers,
  (state: any) => state.companyUsers
);

/**
 * Get all operations
 */
export const getApplicationUserOperations = createSelector(
  getApplicationUsers,
  (state: any) => state.operations
);

/**
 * Get email valid
 */
export const getUserEmailValidity = createSelector(
  getApplicationUsers,
  (state: ApplicationUsersState) => state?.isEmailValid ?? null
);
